<template>
  <QCardSection class="bg-grey-9 text-grey-1">
    <div v-if="loading" class="flex justify-center q-pa-md">
      <QSpinner size="md" color="grey-3" />
    </div>
    <div v-else>
      <QCardSection
        v-if="reviewState"
        class="column justify-center text-center"
      >
        <span>Quote Ref: {{ erpquote.erpQuoteRef }}</span>
        <div>
          <h5 class="q-mt-md q-mb-xs column inline">
            {{ price.monthlyRentalNet | currency }}
          </h5>
          <span class="text-body3 text-grey-5"> (ex gst)</span>
        </div>
        <span class="text-body3 text-grey-5">Per Month</span>
        <span class="text-body3 text-grey-5">
          {{ erpquote.leaseTerm }} months - {{ erpquote.kmsPerYear }}km
        </span>
      </QCardSection>
      <div v-else>
        <div class="row items-center q-pb-sm justify-between">
          <span class="text-bold text-body3">Terms</span>
          <span
            class="text-body3 text-grey-5"
            v-if="erpquote.leaseTerm && erpquote.kmsPerYear"
          >
            {{ erpquote.leaseTerm }} months - {{ erpquote.kmsPerYear }}km
          </span>
        </div>
        <div class="row items-center q-pb-sm justify-between">
          <div>
            <span class="text-bold text-body3">Estimated Cost</span>
            <span class="text-bold text-body4"> (ex gst)</span>
          </div>
          <div class="text-body3 text-grey-5">
            <span>{{ price.monthlyRentalNet | currency }}</span>
            <span v-if="price.monthlyRentalNet">/mo</span>
          </div>
        </div>
      </div>
      <QSeparator dark spaced />
      <QCardSection v-if="reviewState" class="column justify-center">
        <span class="text-bold text-center">Your Driveaway Price</span>
        <div class="text-center">
          <span class="text-grey-5 text-subtitle1">
            {{ price.onRoadCost | currency }}
          </span>
        </div>
      </QCardSection>
      <div v-else class="row items-center q-pt-sm justify-between">
        <div>
          <span class="text-bold text-body3">Your Driveaway Price</span>
        </div>
        <span class="text-body3 text-grey-5">
          {{ price.onRoadCost | currency }}
        </span>
      </div>
      <div class="row items-center q-mt-xs justify-between">
        <span class="text-body4">
          Comparable Weekly Estimate (ex gst)
        </span>
        <span class="text-body4 text-grey-5">
          {{ price.weeklyRentalNet | currency }}
        </span>
      </div>
    </div>
  </QCardSection>
</template>

<script>
import {QCardSection, QSeparator, QSpinner} from 'eclipx.ui';
import {mapState} from 'vuex';

export default {
  name: 'SummaryCardLease',
  props: {
    loading: Boolean
  },
  computed: {
    ...mapState({
      erpquote: (state) => state.quote.quote.erpquote,
      price: (state) => state.quote.quote.erpquote.price
    }),
    reviewState: function() {
      return this.$route.name === 'quoteReview';
    }
  },
  components: {
    QSeparator,
    QCardSection,
    QSpinner
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped></style>
